"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateWithOptions = exports.validate = void 0;
// @ts-ignore
const caster_1 = require("./caster");
function validate(declaration, candidate) {
    if (arguments.length === 0) {
        return validate;
    }
    else if (arguments.length === 1) {
        return (c) => validate(declaration, c);
    }
    return validateWithOptions(declaration, {}, candidate);
}
exports.validate = validate;
function validateWithOptions(declaration, options, candidate) {
    if (arguments.length === 0) {
        return validateWithOptions;
    }
    else if (arguments.length === 1) {
        return (o) => (c) => validateWithOptions(declaration, o, c);
    }
    const caster = caster_1.createCaster(declaration, options);
    const { candidate: castedCandidate, ...validation } = caster(candidate);
    if (validation.isValid) {
        return [];
    }
    else {
        return validation.invalidations;
    }
}
exports.validateWithOptions = validateWithOptions;
